import { Component } from '@angular/core'
import { credits } from '@states/constants'

@Component({
    selector: 'app-footer12',
    imports: [],
    templateUrl: './footer12.component.html',
    styles: ``
})
export class Footer12Component {
  creditsBy = credits
}
